import { createSelector } from '@reduxjs/toolkit';

import { names } from 'Addons';
import { fitmentSearchFieldsSelector, vehicleSelectionSelector } from 'Core/selectors/fitmentSearch/index';
import type { ReduxStateType } from 'Core/store';
import type { FacetValueBase } from 'Models/index';
import requestConfig from 'Models/uiConfig/requestConfig';
import { createFacetValueArraySelector } from 'Modules/selectors';
import { isTruthy } from 'Utils/guards';

type SelectorMap<T> = Record<string, ((state: ReduxStateType) => T) | undefined>;

const getSelectors = <T>(map: SelectorMap<T>): Array<(state: ReduxStateType) => T> =>
  names.map((name) => map[name]).filter(isTruthy);

const preselectionSelectorsMap: SelectorMap<FacetValueBase[]> = {
  fitmentSearch: vehicleSelectionSelector,
  search: () => requestConfig.localPreselection,
};
const preselectionSelectors = getSelectors(preselectionSelectorsMap);

export const searchPreselectionSelector = createFacetValueArraySelector(
  preselectionSelectors,
  (...selections: FacetValueBase[][]): FacetValueBase[] => selections.flat(),
);

const autocompleteSearchFields = [...requestConfig.autocomplete.fields, 'FilterByVehicle'];
const autocompleteFieldsSelectorsMap: SelectorMap<string[]> = {
  fitmentSearch: (state: ReduxStateType) => fitmentSearchFieldsSelector(state),
  search: () => autocompleteSearchFields,
};
const autocompleteFieldsSelectors = getSelectors(autocompleteFieldsSelectorsMap);
const autocompleteFieldsSelector = createSelector(
  autocompleteFieldsSelectors,
  (...fields: string[][]): string[] => fields.flat(),
);

export const autocompletePreselectionSelector = createFacetValueArraySelector(
  // This is a bad fix to make this selector work on fitmentSearch parts page
  // TODO: when extracting of URL handling logic is done,
  //  change this selector back to use only searchPreselectionSelector
  (state: ReduxStateType) => state.search.request.selection,
  searchPreselectionSelector,
  autocompleteFieldsSelector,
  (selection, preselection, fields) =>
    [...selection, ...preselection].filter((sel) => {
      return fields.includes(sel.field);
    }),
);
